module.exports = __webpack_public_path__ + "img/logo.b6c05cfc.png";